import { serviceConfigSchema } from './SharedServiceConfig.js';

// ============================================================================
// Core Schema
// ============================================================================
const internalFeesServiceConfigSchema = serviceConfigSchema;
// ============================================================================
// DTO Schema
// ============================================================================
const internalFeesServiceConfigDtoSchema = serviceConfigSchema;

export { internalFeesServiceConfigDtoSchema, internalFeesServiceConfigSchema };
//# sourceMappingURL=InternalFeesServiceConfig.js.map
